import { Component, OnInit, Injector } from '@angular/core';
import {MatCardModule} from '@angular/material/card'
import { ValidationErrors } from '@angular/forms';
import { NotificationService } from '../../services/notification.service';

import { ContactService } from '../../services/contact.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  data: any = {};
  notifier = this.injector.get(NotificationService);

  constructor(private _contactservice: ContactService,private injector: Injector) { }

  ngOnInit() {
    this.loadScript('../../assets/js/main.js');
    this.data.cinterest = "IT Project";
    this.data.caboutus = "Friend / Referral";

  }


  public loadScript(url: string) {
    const body = <HTMLDivElement> document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  }


  onSubmit() {
    this._contactservice.enquireRequest(this.data).subscribe(data => this.data = data,error => this.notifier.showError(error.message),() => {this.notifier.showSuccess("Message Sent!");});
    //alert(JSON.stringify(this.data));
  }
  


  getErrorMsg(ftype: string, err: ValidationErrors ){
    var msg: string = "";
    
    switch(ftype){
        case "cname":{
          if(err.required){
            msg = "Name is required!";
          }
          else
          {
            msg = "Name is Invalid!";
          }
          break;
        }
        case "cemail":{
          if(err.required){
          msg = "Email is required!"
          }
          else
          {
            msg = "Email address is Invalid!";
          }
          break;
        }

    }
    return msg;
}
}
